import { Tag } from 'antd';
import React, { useEffect, useState } from 'react';

const CountdownTimer = ({ targetDate }) => {
  const calculateTimeLeft = () => {
    const now = new Date();
    const target = new Date(targetDate);
    const difference = target - now;

    const addLeadingZero = (num) => (num < 10 ? `0${num}` : num);

    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: addLeadingZero(Math.floor(difference / (1000 * 60 * 60 * 24))),
        hours: addLeadingZero(Math.floor((difference / (1000 * 60 * 60)) % 24)),
        minutes: addLeadingZero(Math.floor((difference / 1000 / 60) % 60)),
        seconds: addLeadingZero(Math.floor((difference / 1000) % 60)),
      };
    } else {
      timeLeft = {
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00',
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  }, [timeLeft]);

  return (
    <div className="d-flex flex-column align-items-center justify-content-center gap-1">
      <p className="">Subscription Reset In</p>
      <div className="font-text-bold d-flex align-items-center gap-1">
        <p className="time-unit-area">
          <Tag className="time-unit" color="processing">{timeLeft?.days}</Tag>
          <span className="time-title">Day</span>
        </p>
        <p className="time-unit-area">
          <Tag className="time-unit" color="processing">{timeLeft?.hours}</Tag>
          <span className="time-title">hour</span>
        </p>
        <p className="time-unit-area">
          <Tag className="time-unit" color="processing">{timeLeft?.minutes}</Tag>
          <span className="time-title">min</span>
        </p>
        <p className="time-unit-area">
          <Tag className="time-unit" color="processing">{timeLeft?.seconds}</Tag>
          <span className="time-title">sec</span>
        </p>
      </div>
    </div>
  );
};

export default CountdownTimer;
